var $b6b0ea1b94a7633c$exports = {};
$b6b0ea1b94a7633c$exports = {
  "dragDescriptionKeyboard": "Tryk p\xE5 Enter for at starte med at tr\xE6kke.",
  "dragDescriptionKeyboardAlt": "Tryk p\xE5 Alt + Enter for at starte med at tr\xE6kke.",
  "dragDescriptionLongPress": "Tryk l\xE6nge for at starte med at tr\xE6kke.",
  "dragDescriptionTouch": "Dobbelttryk for at starte med at tr\xE6kke.",
  "dragDescriptionVirtual": "Klik for at starte med at tr\xE6kke.",
  "dragItem": function dragItem(args) {
    return "Tr\xE6k ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Tr\xE6k ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valgt element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valgte elementer");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Tryk p\xE5 Enter for at tr\xE6kke ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valgte element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valgte elementer");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Tryk p\xE5 Alt + Enter for at tr\xE6kke ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valgte element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valgte elementer");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Tryk l\xE6nge for at tr\xE6kke ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valgte element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valgte elementer");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Startet med at tr\xE6kke. Tryk p\xE5 Tab for at g\xE5 til et slip-m\xE5l, tryk derefter p\xE5 Enter for at slippe, eller tryk p\xE5 Escape for at annullere.",
  "dragStartedTouch": "Startet med at tr\xE6kke. G\xE5 til et slip-m\xE5l, og dobbelttryk derefter for at slippe.",
  "dragStartedVirtual": "Startet med at tr\xE6kke. G\xE5 til et slip-m\xE5l, og klik eller tryk derefter p\xE5 enter for at slippe.",
  "dropCanceled": "Slip annulleret.",
  "dropComplete": "Slip fuldf\xF8rt.",
  "dropDescriptionKeyboard": "Tryk p\xE5 Enter for at slippe. Tryk p\xE5 Escape for at annullere tr\xE6kning.",
  "dropDescriptionTouch": "Dobbelttryk for at slippe.",
  "dropDescriptionVirtual": "Klik for at slippe.",
  "dropIndicator": "slip-indikator",
  "dropOnItem": function dropOnItem(args) {
    return "Slip p\xE5 ".concat(args.itemText);
  },
  "dropOnRoot": "Slip p\xE5",
  "endDragKeyboard": "Tr\xE6kning. Tryk p\xE5 enter for at annullere tr\xE6k.",
  "endDragTouch": "Tr\xE6kning. Dobbelttryk for at annullere tr\xE6k.",
  "endDragVirtual": "Tr\xE6kning. Klik for at annullere tr\xE6kning.",
  "insertAfter": function insertAfter(args) {
    return "Inds\xE6t efter ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Inds\xE6t f\xF8r ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Inds\xE6t mellem ".concat(args.beforeItemText, " og ").concat(args.afterItemText);
  }
};
export { $b6b0ea1b94a7633c$exports as default };